/* tslint:disable */
/* eslint-disable */
/**
 * Clients API
 * API des listes de clients (personnes ayant au moins un contrat)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminClientListItem } from './AdminClientListItem';
import {
    AdminClientListItemFromJSON,
    AdminClientListItemFromJSONTyped,
    AdminClientListItemToJSON,
    AdminClientListItemToJSONTyped,
} from './AdminClientListItem';

/**
 * 
 * @export
 * @interface GetAdminClientListResponse
 */
export interface GetAdminClientListResponse {
    /**
     * 
     * @type {number}
     * @memberof GetAdminClientListResponse
     */
    totalCount: number;
    /**
     * 
     * @type {Array<AdminClientListItem>}
     * @memberof GetAdminClientListResponse
     */
    items: Array<AdminClientListItem>;
}

/**
 * Check if a given object implements the GetAdminClientListResponse interface.
 */
export function instanceOfGetAdminClientListResponse(value: object): value is GetAdminClientListResponse {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetAdminClientListResponseFromJSON(json: any): GetAdminClientListResponse {
    return GetAdminClientListResponseFromJSONTyped(json, false);
}

export function GetAdminClientListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAdminClientListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(AdminClientListItemFromJSON)),
    };
}

export function GetAdminClientListResponseToJSON(json: any): GetAdminClientListResponse {
    return GetAdminClientListResponseToJSONTyped(json, false);
}

export function GetAdminClientListResponseToJSONTyped(value?: GetAdminClientListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(AdminClientListItemToJSON)),
    };
}

